import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="w-full bg-[#FAFAF7] py-6 md:py-24 px-4 md:px-6" data-id="element-133">
      <div className="max-w-6xl mx-auto" data-id="element-134">
        <div className="grid md:grid-cols-2 gap-6 md:gap-12 items-center" data-id="element-135">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-136">
            <h1 className="font-['Playfair_Display'] text-4xl md:text-5xl lg:text-6xl font-bold text-[#1C1C1C] leading-tight mb-4 md:mb-6" data-id="element-137">
              Tu casa no es un baño público: Recuperá el olor de tu hogar en 72
              horas.
            </h1>
            <h2 className="text-lg md:text-xl text-[#1C1C1C]/80 mb-5 md:mb-8 leading-relaxed" data-id="element-138">
              El protocolo práctico para que tu gato deje de orinar en el sofá,
              la cama y las alfombras sin usar castigos ni productos que no
              funcionan.
            </h2>
            <motion.button whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} onClick={() => document.getElementById('precio')?.scrollIntoView({
            behavior: 'smooth'
          })} className="w-full md:w-auto bg-[#2D8C5A] text-white font-semibold px-8 py-4 rounded-lg text-lg hover:bg-[#267049] transition-colors cursor-pointer" data-id="element-139">
              QUIERO RECUPERAR MI CASA EN 72 HORAS
            </motion.button>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="flex justify-center" data-id="element-140">
            <img src="https://cdn.magicpatterns.com/uploads/duihKqK7ppWH63yAv2hEao/heylloyd-image-1774873305298.png" alt="Paz en la Bandeja - Guía digital" className="w-full max-w-md rounded-lg shadow-2xl" data-id="element-141" />
          </motion.div>
        </div>
      </div>
    </section>;
}